import { State } from "@web-app/types";
import http from "@web-app/utils/http";

export const getMarkets = async (countryCode: string = "US") => {
  try {
    const response = await http.get<State[]>(
      `/geolocation/markets/${countryCode}`,
    );
    const map = new Map<string, State>();
    response.data.forEach((state) => {
      map.set(state.id, state);
    });
    return map;
  } catch {
    // Fallback to countries endpoint if markets endpoint fails
    const response = await http.get<State[]>(
      `/geolocation/countries/${countryCode}/states`,
    );
    const map = new Map<string, State>();
    response.data.forEach((state) => {
      map.set(state.id, state);
    });
    return map;
  }
};
